<template>
  <div role="group">
    <label class="mb-1">{{ etiqueta }}</label>
    <b-input-group>
      <b-input-group-text
        v-if="prepend === 'true'"
        slot="prepend"
        class="bg-white"
      >
        <font-awesome-icon v-if="icono" icon="envelope" />
        {{ textInputgroup ? textInputgroup : "" }}</b-input-group-text
      >
      <b-form-input
        :data-testid="dataTesting"
        :maxlength="maxlength"
        :class="'rounded placeholder'"
        :type="type ? type : 'text'"
        :state="estado"
        :value="value"
        :placeholder="placeholder"
        @change.native="change"
        @input.native="handler"
        @blur="blur"
        @keyup="keyup"
        trim
        autocomplete="off"
      ></b-form-input>
    </b-input-group>
    <b-form-invalid-feedback class="d-block mt-1">{{
      mensajeError
    }}</b-form-invalid-feedback>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faEnvelope);
export default {
  props: [
    "value",
    "estado",
    "placeholder",
    "mensajeError",
    "etiqueta",
    "prepend",
    "textInputgroup",
    "type",
    "maxlength",
    "dataTesting",
    "icono"
  ],
  components: {
    FontAwesomeIcon
  },
  methods: {
    handler(evento) {
      this.$emit("input", evento.target.value);
    },
    change(evento) {
      this.$emit("change", evento);
    },
    blur(evento) {
      this.$emit("blur", evento);
    },
    keyup(evento) {
      this.$emit("keyup", evento);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generales/inputs/InputTextWrapper.vue